import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

let module = {
  endpoint: 'categoryDiscount',
  getNew: {
    deleted: false,
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'discountValue',
        title: 'Valore',
        sortField: 'discountValue'
      },
      {
        name: 'discountType.name',
        title: 'Tipo Sconto',
        sortField: 'discountType.name'
      },
      {
        name: 'validFrom',
        title: 'Valido da',
        sortField: 'validFrom',
        callback: baseApplicationItem.toDate
      },
      {
        name: 'validTo',
        title: 'Valido al',
        sortField: 'validTo',
        callback: baseApplicationItem.toDate
      },
      {
        name: 'category.name',
        title: 'Category',
        sortField: 'category.name'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
}

export default merge(module, baseApplicationItem)




// WEBPACK FOOTER //
// ./src/application/categoryDiscounts.js